import { render, staticRenderFns } from "./THGCar.vue?vue&type=template&id=4549f4aa"
import script from "./THGCar.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports